import { Injectable } from '@angular/core';

@Injectable()
export class PayoutCreation {
  public _creation: any[] = [
    { value: 0, name: 'TODOS' },
    { value: 1, name: 'Este Mes' },
    { value: 2, name: 'Esta Semana' },
    { value: 3, name: 'Hoy' },
    { value: 4, name: 'Ayer' },
    { value: 5, name: 'Semana Pasada' },
    { value: 6, name: 'Mes Pasado' },
    { value: 7, name: 'Rango' }
  ];

  constructor() { }
}

@Injectable()
export class PayoutCommerceCreation {
  public _creation: any[] = [
    { value: 0, name: 'TODOS (3*)' },
    { value: 1, name: 'Este Mes' },
    { value: 2, name: 'Esta Semana' },
    { value: 3, name: 'Hoy' },
    { value: 4, name: 'Ayer' },
    { value: 5, name: 'Semana Pasada' },
    { value: 6, name: 'Mes Pasado' },
    { value: 7, name: 'Rango' }
  ];

  constructor() { }
} 

@Injectable()
export class PayoutStatus {
  public _status: any[] = [
    { value: 0, name: 'TODOS' },
    { value: 1, name: 'Pendiente' },
    { value: 2, name: 'Aprobado' },
    { value: 3, name: 'Completado' },
    { value: 4, name: 'Cancelado' },
    { value: 5, name: 'Creando' },
    { value: 6, name: 'Confirmando' },
    { value: 7, name: 'Cancelando' }
  ];

  constructor() { }
}

@Injectable()
export class PayoutCommerceStatus {
  public _commerceStatus: any[] = [
    { value: 0, name: 'TODOS' },
    { value: 1, name: 'Pendiente' },
    { value: 2, name: 'Aprobado' },
    { value: 3, name: 'Completado' },
    { value: 4, name: 'Creando' },
    { value: 5, name: 'Confirmando' },
    { value: 7, name: 'Confirmando con errores'}
  ];

  constructor() { }
}